import {
    BaseBoxShapeUtil,
    HTMLContainer,
    RecordProps,
    T,
    TLBaseShape,
    stopEventPropagation,
    TLResizeHandle,
} from 'tldraw'
import {FetchImagesTaskProcess, GenerateTagsTaskProcess, taskProcess, TaskStatusType} from "../types/taskFlow.types";
import './styles.css'
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch';
import {useCanvas2Control} from "../hooks/useCanvas2Control";
import {TaskLoading} from "../icons";
import React from "react";

type IMyEditableShape = TLBaseShape<
    'tags-shape',
    {
        index: number,
        text: string,
        status: string,
        h: number,
        w: number,
        imageData?: taskProcess,
        taskId?: number,
        loading?: boolean
    }
>

export class TagsShapeUtil extends BaseBoxShapeUtil<IMyEditableShape> {
    static override type = 'tags-shape' as const
    static override props: RecordProps<IMyEditableShape> = {
        index: T.number,
        text: T.string,
        status: T.string,
        w: T.number,
        h: T.number,
        imageData: T.any,
        taskId: T.any,
        loading: T.any
    }


    getDefaultProps(): IMyEditableShape['props'] {
        return {
            index: 1,
            text: '',
            status: '待确认',
            w: 360,
            h: 360,
            imageData: undefined,
            taskId: 0,
            loading: false
        }
    }

    // 禁用调整大小功能
    override canResize = (_shape: IMyEditableShape) => {
        return false
    }

    // 隐藏调整大小的控制点
    override hideResizeHandles = (_shape: IMyEditableShape): boolean => {
        return true
    }

    // [2]
    component(shape: IMyEditableShape) {
        // [a]
        const isEditing = this.editor.getEditingShapeId() === shape.id


        const temporary_url = process.env.REACT_APP_PROXY_TARGET ?? ''

        return (
                <HTMLContainer
                    id={shape.id}
                    // [b]
                    onPointerDown={(e) => {
                        e.stopPropagation();
                        console.log('啊, 我被点击了')
                    }}
                    style={{
                        pointerEvents: 'all',
                        backgroundColor: '#FFFFFF',
                        fontSize: 14,
                        padding: 0,
                        borderRadius: 8,
                        color: '#444444'
                    }}
                >
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                        height: '30px',
                        justifyContent: 'center',
                        backgroundColor: '#E3F0FF'
                    }}>
                        <div style={{fontWeight: "bold"}}>{shape.props.text}</div>
                        <div style={{color: '#999999'}}>【{shape.props.taskId}】</div>
                    </div>
                    <div style={{width: '100%', height: 'calc(100% - 30px)', display: "flex", alignItems: 'center', justifyContent: "space-around", flexWrap: "wrap"}}>
                        {shape.props.loading && <TaskLoading size={50} />}
                        {
                            !shape.props.loading && (shape.props.imageData?.response as GenerateTagsTaskProcess).data.map(
                                (item, index) => {
                                    return <div className='tagBox'>{item}</div>
                                })
                        }
                    </div>
                </HTMLContainer>
        )
    }

    indicator(shape: IMyEditableShape) {
        // 返回固定大小的indicator
        return <rect width={shape.props.w} height={shape.props.h}/>
    }
}